<!--Basics of this component
1) Gathers the minimum data needed to create a new person.
2) Posts that data
3) Once post completed provides info on what to do next
4) Goes to person detail for new person

-->

<template>
  <div>
    <b-modal
      id="responsible-person-create"
      :title="'Add parent or guardian for ' + person.firstName"
      @hidden="cancelModal()"
      :busy="false"
      return-focus="body"
    >
      <template v-slot:modal-footer="{}">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="md" variant="secondary" @click="cancelModal()">
          Cancel
        </b-button>
        <b-button
          v-if="allValid == true"
          size="md"
          variant="success"
          @click="postData()"
        >
          Save
        </b-button>
      </template>

      <p>
        This will add a parent or guardian record for {{ person.firstName }}.
      </p>
      <p>
        {{ person.firstName }}s' consents and address will be copied to their
        record.
      </p>
      <p>
        When you press save you will be taken the the parent or guardians record
      </p>

      <div v-if="error != null" class="text-center">
        <b-spinner variant="danger" type="grow" label="Spinning"></b-spinner>
        <div v-html="error.data"></div>
      </div>

      <div v-if="formError.length > 0" class="text-center">
        <b-spinner variant="danger" type="grow" label="Spinning"></b-spinner>
        <div v-for="(item, key) in formError" :key="key">{{ item.error }}</div>
        <b-button variant="success" @click="formError = []">OK</b-button>
      </div>
      <b-form-group
        id="firstName-1"
        label="First Name"
        label-for="input-1"
        :invalid-feedback="invalidFeedbackFirstName"
        :valid-feedback="validFeedbackFirstName"
        :state="stateFirstName"
      >
        <b-form-input
          id="input-1"
          v-model="firstName"
          :state="stateFirstName"
          trim
        ></b-form-input>
      </b-form-group>

      <b-form-group
        id="lastName-1"
        label="Last Name"
        label-for="input-2"
        :invalid-feedback="invalidFeedbackLastName"
        :valid-feedback="validFeedbackLastName"
        :state="stateLastName"
      >
        <b-form-input
          id="input-2"
          v-model="lastName"
          :state="stateLastName"
          trim
        ></b-form-input>
      </b-form-group>
      <b-form-group
        id="parentType-1"
        label="Relationship Type"
        label-for="parentType-1"
        :invalid-feedback="invalidFeedbackType"
        :valid-feedback="validFeedbackType"
        :state="stateType"
        description="Pick the type of relationship"
      >
        <b-form-select
          @change="validateType()"
          v-model="type"
          :options="typeOptions"
        ></b-form-select>
      </b-form-group>

      <app-add-phone-component
        v-on:changePhoneNo="phoneNumber = $event"
        v-on:changeNumberType="phoneNumberType = $event"
        :fieldsOnly="fieldsOnly"
      ></app-add-phone-component>
    </b-modal>
  </div>
</template>

<script>
import addPhoneComponent from "../contactComponents/contactEditComponents/ContactAddPhoneComponent";
export default {
  components: {
    AppAddPhoneComponent: addPhoneComponent,
  },
  mounted() {
    this.$bvModal.show("responsible-person-create");
  },
  data() {
    return {
      test: "this is the AddPersonHome.vue component",
      firstName: null,
      lastName: null,
      phoneNumber: null,
      phoneNumberType: null,
      fieldsOnly: true,
      formError: [],
      type: null,
      typeOptions: [
        {value: null, text: "Select type of relationship" },
        { value: "Parent", text: "Parent" },
        { value: "Grand Parent", text: "Grand Parent" },
        { value: "Guardian", text: "Guardian" },
        { value: "Other Family", text: "Other Family" },
      ],
      stateType: null,
    };
  },

  computed: {
    allValid() {
      if (
        this.stateFirstName &&
        this.stateLastName &&
        this.stateType &&
        this.statePhone
      ) {
        return true;
      }
      return false;
    },
    statePhone() {
      // phone number and type are only writen to this components data once validated in the add phone component
      if (
        (this.phoneNumber != null && this.phoneNumberType != null) ||
        (this.phoneNumber == null && this.phoneNumberType == null)
      ) {
        return true;
      }
      return false;
    },
    error() {
      return this.$store.getters.axiosError;
    },
    stateFirstName() {
      if (this.firstName == null) {
        return null;
      }
      if (this.firstName.length > 0) {
        return true;
      }
      return false;
    },
    stateLastName() {
      if (this.lastName == null) {
        return null;
      }
      if (this.lastName.length > 2) {
        return true;
      }
      return false;
    },

    invalidFeedbackFirstName() {
      if (this.stateFirstName == null || this.stateFirstName == true) {
        return null;
      }
      return "Enter at least on charecter";
    },
    validFeedbackFirstName() {
      if (this.stateFirstName == null || this.stateFirstName == false) {
        return null;
      }
      return "Thanks";
    },

    invalidFeedbackLastName() {
      if (this.stateLastName == null || this.stateLastName == true) {
        return null;
      }
      return "Enter at least on charecter";
    },
    validFeedbackLastName() {
      if (this.stateLastName == null || this.stateLastName == false) {
        return null;
      }
      return "Thanks";
    },
    invalidFeedbackType() {
      if (this.stateType == false) {
        return "You need to pick the type of relationship";
      }
      return null;
    },
    validFeedbackType() {
      if (this.stateType == true) {
        return "Thanks";
      }
      return null;
    },
    person() {
      return this.$store.getters.person;
    },
  },

  methods: {
    validateType() {
      if (this.type == null) {
        this.stateType = false;
        return false;
      }
      this.stateType = true;
      return true;
    },
    postData() {
      // build payload from form and from person object
      const payload = {
        url: this.$store.getters.urlPrefix + "api/addResponsiblePerson/",
        data: {
          firstName: this.firstName,
          lastName: this.lastName,
          consentToTravel: false,
          internalMediaConsent: false,
          externalMediaConsent: false,
          gdprConsent: this.person.gdprConsent,
          consideredDisabled: false,
          currentMember: this.person.currentMember,
          addressLine1: this.person.addressLine1,
          addressLine2: this.person.addressLine2,
          addressLine3: this.person.addressLine3,
          postCode: this.person.postCode,
          friend: [
            {
              person: this.person.id,
              typeOfFriend: this.type,
              friend: null,
            },
            {
              person: null,
              typeOfFriend: "Child",
              friend: this.person.id,
            },
          ],
          phone:[
            {
              numberType:this.phoneNumberType,
              phoneNumber:this.phoneNumber,

            }
          ],
          responsiblePerson: true,
        },
        mutationName: "person",
      };
     
      this.$store.dispatch("genericPostApiCall", payload).then((resolve) => {
        // We need the id of the newly created person (yes we could use this.person.id from the computed person object)
        // but this is nice and explicit.
        // now navigate to responsible person page which will set up the data correctly
        const responsiblePersonId = resolve.data.id;
        this.$router.push({
          name: "personDetail",
          params: { id: responsiblePersonId },
        });
        this.cancelModal();
      });
    },

    cancelModal() {
      // clear any errors
      this.$store.dispatch("axiosError", null);
      this.$router.replace({
        name: "personDetail",
        params: { id: this.person.id },
      });
    },
  },
};
</script>

<style scoped></style>
